<template>
  <div>
    <ag-grid-vue
      :style="{ width, height }"
      domLayout="autoHeight"
      class="ag-theme-alpine mb-4"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="items"
      :frameworkComponents="frameworkComponents"
      @grid-ready="onFirstDataRendered"
    ></ag-grid-vue>
    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="dataOptions.totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import TableActions from "@/components/common/table-actions";

export default {
  name: "AppTable",
  components: {
    AgGridVue,
  },
  props: {
    headers: { type: Array },
    items: { type: Array },
    cols: { type: Number },
    type: { type: String },
    options: { type: Object },
    component: { type: String },
    isUpdated: { type: Boolean },
    dataOptions: { type: [Object, Array] },
  },
  data: () => ({
    page: 1,
    show: false,
    selected: [],
    sogSelected: {},
    showSelect: false,
    tableOptions: {},
    currentPage: 1,
    customSort: {
      sortBy: "orderID",
      sortDesc: true,
    },
    gridOptions: null,
    columnDefs: null,
    defaultColDef: null,
    rowData: null,
    gridApi: null,
    frameworkComponents: null,
    height: "100%",
    width: "100%",
  }),
  mounted() {
    let vm = this;
    if (vm.type === "addressLookup") vm.showSelect = true;
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "Actions",
        field: "actions",
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function (param) {
            switch (param.type) {
              case "appointment":
                vm.$emit("showAppointment", param);
                break;
              case "order":
                vm.showOriginal(param);
                break;
              case "retrigger":
                vm.$emit("retrigger", param);
                break;
              case "updateOnIseek":
                vm.$emit("updateOnIseek", param);
                break;
            }
          },
        },
        maxWidth: 140,
      },
      {
        headerName: "Type",
        field: "orderType",
        sortable: true,
        maxWidth: 100,
        filter: true,
      },
      {
        headerName: "Order ID",
        field: "nbnOrderId",
        sortable: true,
        filter: true,
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function (param) {
            if (param.orderType === "5G") vm.retrieve5GOrder(param);
            else vm.retrieveOrder(param.nbnOrderId);
          },
        },
        maxWidth: 195,
      },
      {
        headerName: "System ID",
        field: "systemId",
        sortable: true,
        maxWidth: 140,
        filter: true,
      },
      {
        headerName: "Customer Name",
        field: "customerName",
        sortable: true,
        filter: true,
        valueGetter: (params) => {
          return `${
            params.data.customerFirstname ? params.data.customerFirstname : ""
          } ${params.data.customerSurname ? params.data.customerSurname : ""}`;
        },
      },
      {
        headerName: "MSN Service ID",
        field: "msn",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Wholesaler Name",
        field: "wholesaler",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Auth Date",
        field: "customerAuthDate",
        sortable: true,
        sort: "desc",
        valueFormatter: (param) => {
          return vm.$options.filters.formatDateTime(param.value);
        },
        maxWidth: 150,
        filter: true,
      },
      {
        headerName: "Status",
        field: "status",
        sortable: true,
        valueFormatter: (param) => {
          return vm.$options.filters.formatStatus(param.value);
        },
        maxWidth: 150,
      },
      {
        headerName: "Ticket #",
        field: "kayakoConversation",
        sortable: true,
        filter: true,
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function (param) {
            vm.showKayakoConversation(param);
          },
          shouldRedirect: vm.shouldRedirect,
        },
        maxWidth: 120,
      },
    ];

    vm.defaultColDef = {
      autoHeight: true,
    };

    vm.frameworkComponents = {
      tableActions: TableActions,
    };
  },
  methods: {
    paginationChange(val) {
      this.$emit("paginationChange", val);
    },
    onFirstDataRendered(grid) {
      grid.api.sizeColumnsToFit();
    },
    showKayakoConversation(item) {
      let newItem = item.customerReference;
      if (item.customerReference.includes("_")) {
        newItem = item.customerReference.slice(
          item.customerReference.indexOf("_") + 1,
          item.customerReference.length
        );
      }
      var authDate = new Date(item.customerAuthDate);
      var zammadDeployDate = new Date("2024-04-18");
      if(authDate >= zammadDeployDate)
      {
        window.open(
          `https://zammad.vonex.com.au/#search/number:${newItem}`,
          "_blank"
        );
      } else {
        window.open(
          `https://vonex.kayako.com/agent/conversations/${newItem}`,
          "_blank"
        );
      }
    },
    reset() {
      let vm = this;
      vm.selected = [];
    },
    emit(action) {
      let vm = this;
      vm.$emit(action);
    },
    setSelected(item) {
      let vm = this;
      vm.$emit("selected", item);
    },
    resetSelected() {
      let vm = this;
      vm.sogSelected = {};
      vm.currentPage = 1;
    },
    retrieveOrder(id) {
      let vm = this;
      vm.$emit("showOrderDetails", id);
    },
    updateOrder(item) {
      let vm = this;
      vm.$emit("updateOrder", item);
    },
    cancelOrder(item) {
      let vm = this;
      vm.$emit("cancelOrder", item);
    },
    retrieve5GOrder(item) {
      let vm = this;
      vm.$emit("show5GDetails", item);
    },
    showOriginal(item) {
      let vm = this;
      vm.$emit("showOriginal", item);
    },
    disableIcon(item, button) {
      let disable = true;
      if (item.orderType === "NBN") {
        switch (button) {
          case "addressQuery":
            disable = !item.locationId;
            break;
          case "sq":
            disable = !item.locationId;
            break;
          case "appointment":
            disable = !item.appointmentId || item.appointmentId === "NA";
            break;
        }
      } else {
        if (button === "addressQuery" || button === "sq") disable = false;
      }

      return disable;
    },
  },
  computed: {
    shouldRedirect() {
      let vm = this;
      let redirect = true;

      if ((vm.impersonating !== null && !vm.isUserMember) || !vm.isAdmin)
        redirect = false;

      return redirect;
    },
  },
  filters: {
    setStatus(value) {
      switch (value) {
        case 0:
          return "New";
        case 1:
          return "In Progress";
        case 2:
          return "Signed";
        case 3:
          return "Completed";
        case 4:
          return "Cancelled";
        case 5:
          return "Rejected";
        default:
          return "Unknown";
      }
    },
  },
  watch: {
    selected: function () {
      let vm = this;
      vm.$emit("selected", vm.selected);
    },
  },
};
</script>

<style lang="scss" scoped>
.appointment {
  ::v-deep thead tr {
    background-color: #1e1e28;
    color: #fff;
  }

  ::v-deep thead tr th span {
    color: #fff;
    font-size: 15px !important;
  }

  ::v-deep thead tr th .v-icon::before {
    color: #fff !important;
  }

  .kayako {
    text-decoration: underline;
    color: #2f5578 !important;
    cursor: pointer;
    font-weight: bold;
  }

  ::v-deep .v-data-table-header-mobile {
    display: none;
  }

  ::v-deep tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05) !important;
  }

  ::v-deep .v-data-table__mobile-table-row {
    display: block;
  }
}
</style>
